import { useEffect, useState } from 'react';

import { ChevronDownIcon, Timer } from 'lucide-react';
import { Badge, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'twyne-new.ui';

import { HeaderSeparator, ReportDatePicker, ReportHeader, ReportHeaderDates, ReportHeaderDesktopActions, ReportHeaderMobileActions, ReportMenuExpandable, ReportMobileMenu, RunButton } from '@/components/reports/header'

const REFRESH_INTERVALS = [
  { minutes: 0, label: 'Disabled' },
  { minutes: 1, label: '1 minute' },
  { minutes: 2, label: '2 minutes' },
  { minutes: 5, label: '5 minutes' },
  { minutes: 15, label: '15 minutes' },
  { minutes: 30, label: '30 minutes' },
  { minutes: 60, label: '1 hour' },
  { minutes: 120, label: '2 hours' },
]

export default function Header({ sync, handleChangeDates, dates, handleChangeDatesTime, isLoading }) {
  const [refreshIntervalLabel, setRefreshIntervalLabel] = useState('disabled')
  const [intervalState, setIntervalState] = useState(0)
  const [autoRefresh, setAutoRefresh] = useState()
  const [refreshMenuOpen, setRefreshMenuOpen] = useState(false)

  useEffect(() => {
    if (!intervalState) {
      clearInterval(autoRefresh)
    }
  })

  function changeRefreshInterval(intervalInMinutes) {
    clearInterval(autoRefresh)
    const interval = intervalInMinutes * 1000 * 60

    if (interval) {
      setAutoRefresh(setInterval(sync, interval))
    }

    let intervalLabel

    if (intervalInMinutes > 0 && intervalInMinutes < 60) {
      intervalLabel = `${intervalInMinutes} minute${intervalInMinutes > 1 ? "s" : ""}`
    } else if (intervalInMinutes >= 60) {
      intervalLabel = `${intervalInMinutes / 60} hour${intervalInMinutes / 60 > 1 ? "s" : ""}`
    } else {
      intervalLabel = "Disabled"
    }
    setRefreshIntervalLabel(intervalLabel)
    setIntervalState(interval)
  }

  return <>
    <ReportHeader title='Session Report'>
      <ReportHeaderDates>
        <ReportDatePicker dates={dates} onChange={handleChangeDates} />
      </ReportHeaderDates>

      <ReportHeaderDesktopActions>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Badge
              size='lg'
              color='accent'
              variant='outline'
              className='self-center twy-subtle-accent-hover transition-all cursor-pointer'
            >
              Auto-refresh: {refreshIntervalLabel}
              <ChevronDownIcon size={12} />
            </Badge>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {REFRESH_INTERVALS.map(({ minutes, label }) => <DropdownMenuItem key={minutes} onClick={() => changeRefreshInterval(minutes)}>{label}</DropdownMenuItem>)}
          </DropdownMenuContent>
        </DropdownMenu>
      </ReportHeaderDesktopActions>

      <HeaderSeparator />
      <ReportHeaderMobileActions>
        <ReportMobileMenu onOpenChange={open => !open && setRefreshMenuOpen(false)}>
          <ReportMenuExpandable icon={Timer} label={`Auto-refresh: ${refreshIntervalLabel}`} open={refreshMenuOpen} onToggle={() => setRefreshMenuOpen(open => !open)}>
            <div className='pl-7'>
              {REFRESH_INTERVALS.map(({ minutes, label }) => <DropdownMenuItem key={minutes} onSelect={() => changeRefreshInterval(minutes)}>{label}</DropdownMenuItem>)}
            </div>
          </ReportMenuExpandable>
        </ReportMobileMenu>
        <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
      </ReportHeaderMobileActions>
    </ReportHeader>
  </>
}

